import { Link } from "react-router-dom";
import { ScanFace, Mic, Fingerprint, ArrowLeft } from "lucide-react"; // ✅ corrected icons

export default function BiometricValidation() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">Biometric Validation</h1>
                </div>

                <p className="text-gray-600 mb-8">
                    Verify identity with face, voice, or fingerprint. Mix methods for higher assurance.
                </p>

                <section className="grid md:grid-cols-3 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <ScanFace className="w-5 h-5" />  {/* ✅ replaced FaceIcon */}
                            <h3 className="font-semibold">Face Recognition</h3>
                        </div>
                        <p className="text-gray-700 text-sm">
                            Liveness detection, embedding matching, and re-checks during the exam.
                        </p>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Mic className="w-5 h-5" />
                            <h3 className="font-semibold">Voice Recognition</h3>
                        </div>
                        <p className="text-gray-700 text-sm">
                            Short passphrases with anti-spoofing and ambient noise tolerance.
                        </p>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Fingerprint className="w-5 h-5" />
                            <h3 className="font-semibold">Fingerprint (optional)</h3>
                        </div>
                        <p className="text-gray-700 text-sm">
                            Compatible with supported readers for test-center deployments.
                        </p>
                    </div>
                </section>

                <div className="mt-8 flex flex-wrap gap-3">
                    <Link
                        to="/support/contact"
                        className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
                    >
                        Talk to Engineering
                    </Link>
                    <Link
                        to="/solutions/examspro"
                        className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 hover:text-indigo-800 px-5 py-2.5 rounded-full font-semibold transition shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
